<template>
  <div class="input_check">
    <input type="checkbox" :id="id" @change="$emit('custom-checked', !checked)" :disabled="disabled" ref="checkbox" />
    <label
      :for="id"
      :class="{
        checked,
        disabled: disabled,
      }"
      v-html="text"
    ></label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'custom-checked',
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      deafult: '',
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss"></style>
